var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"buttons-wrapper"},[_c('div',[_vm._t("leftTop")],2),_c('div',[_vm._t("rightTop")],2),_c('div',[_vm._t("leftBottom")],2),_c('div',[_vm._t("rightBottom")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }